import { render, staticRenderFns } from "./EditAccount.vue?vue&type=template&id=ba96cbd4&"
import script from "./EditAccount.vue?vue&type=script&lang=js&"
export * from "./EditAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports